import "./maps/google_map_factory";
import "./maps/terminals_location_app";

const DEFAULT_GOOGLE_MAPS_API_KEY = "AIzaSyC3O_M_BrwjMCsLmAOIOGZYIMzyNS2XRms";

function onReady(callback) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", callback, { once: true });
  } else {
    callback();
  }
}

function googleMapsApiKey() {
  return window.RailsConfig?.googleMapsApiKey || DEFAULT_GOOGLE_MAPS_API_KEY;
}

function publishMap() {
  if (window.google?.maps || document.querySelector('script[data-google-maps-loader="true"]')) return;

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.dataset.googleMapsLoader = "true";
  script.src =
    "https://maps.googleapis.com/maps/api/js?v=3.exp" +
    `&key=${encodeURIComponent(googleMapsApiKey())}` +
    "&libraries=places" +
    "&callback=GoogleMapFactory.build";

  document.body.appendChild(script);
}

onReady(() => {
  const $ = window.jQuery;
  if (!$) return;

  if ($(".map-loader").length > 0) {
    $(".map-loader").on("click", function (event) {
      event.preventDefault();

      $(this).attr("data-map-displayed", true).hide();
      $("[data-google-map-app]").each(function () {
        $(this).parent().show();
      });

      publishMap();
    });

    return;
  }

  if ($("[data-google-map-app]").length > 0) {
    publishMap();
  }
});
